import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const SharedAccessLinkEditModal = ({ show, onHide, onUpdate, link, isLoading }) => {
  const { t } = useTranslation();
  const [description, setDescription] = useState('');

  useEffect(() => {
    if (link) {
      setDescription(link.description || '');
    }
  }, [link]);

  const handleSubmit = (e) => {
    e.preventDefault();

    onUpdate({
      description: description.trim() || undefined,
    });
  };

  const handleClose = () => {
    onHide();
  };

  if (!link) return null;

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('shared-access.edit-link')}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className='mb-3'>
            <Form.Label>{t('shared-access.description')}</Form.Label>
            <Form.Control
              type='text'
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder={t('shared-access.description-placeholder')}
            />
            <Form.Text className='text-muted'>{t('shared-access.description-help')}</Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleClose} disabled={isLoading}>
            {t('forms.cancel')}
          </Button>
          <Button variant='primary' type='submit' disabled={isLoading}>
            {isLoading ? t('forms.loading') || 'Loading...' : t('shared-access.save')}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default SharedAccessLinkEditModal;

